import {CRITERIA_TYPE, CRITERIA_TYPE_NAME} from "../const/constant";

export const convertCriteriaType = (type: CRITERIA_TYPE) => {
  return type ? CRITERIA_TYPE_NAME[type as keyof typeof CRITERIA_TYPE_NAME] : "";
}